/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { getEntities as getPaymentSchemes } from 'app/entities/payment-scheme/payment-scheme.reducer';
import { getEntities as getHospitalProcedures } from 'app/entities/hospital-procedure/hospital-procedure.reducer';
import { getEntities as getParamedics } from 'app/entities/paramedic/paramedic.reducer';
import { ReferralChargeType } from 'app/shared/model/enumerations/referral-charge-type.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { HikeType } from 'app/shared/model/enumerations/hike-type.model';
import { createEntity, getEntity, reset, updateEntity } from './paramedic-referral-charge.reducer';

export const ParamedicReferralChargeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const doctors = useAppSelector(state => state.doctor.entities);
  const hospitals = useAppSelector(state => state.hospital.entities);
  const paymentSchemes = useAppSelector(state => state.paymentScheme.entities);
  const hospitalProcedures = useAppSelector(state => state.hospitalProcedure.entities);
  const paramedics = useAppSelector(state => state.paramedic.entities);
  const paramedicReferralChargeEntity = useAppSelector(state => state.paramedicReferralCharge.entity);
  const loading = useAppSelector(state => state.paramedicReferralCharge.loading);
  const updating = useAppSelector(state => state.paramedicReferralCharge.updating);
  const updateSuccess = useAppSelector(state => state.paramedicReferralCharge.updateSuccess);
  const referralChargeTypeValues = Object.keys(ReferralChargeType);
  const addedByTypeValues = Object.keys(AddedByType);
  const hikeTypeValues = Object.keys(HikeType);

  const handleClose = () => {
    navigate(`/paramedic-referral-charge${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDoctors({}));
    dispatch(getHospitals({}));
    dispatch(getPaymentSchemes({}));
    dispatch(getHospitalProcedures({}));
    dispatch(getParamedics({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.charge !== undefined && typeof values.charge !== 'number') {
      values.charge = Number(values.charge);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.emergencyHike !== undefined && typeof values.emergencyHike !== 'number') {
      values.emergencyHike = Number(values.emergencyHike);
    }
    if (values.hishRiskHike !== undefined && typeof values.hishRiskHike !== 'number') {
      values.hishRiskHike = Number(values.hishRiskHike);
    }
    if (values.startDate !== undefined && typeof values.startDate !== 'number') {
      values.startDate = Number(values.startDate);
    }
    if (values.endDate !== undefined && typeof values.endDate !== 'number') {
      values.endDate = Number(values.endDate);
    }

    const entity = {
      ...paramedicReferralChargeEntity,
      ...values,
      doctor: doctors.find(it => it.id.toString() === values.doctor?.toString()),
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
      scheme: paymentSchemes.find(it => it.id.toString() === values.scheme?.toString()),
      procedure: hospitalProcedures.find(it => it.id.toString() === values.procedure?.toString()),
      paramedic: paramedics.find(it => it.id.toString() === values.paramedic?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          referralChargeType: 'CONSULTATION',
          addedByType: 'DOCTOR',
          modifiedByType: 'DOCTOR',
          emergencyHikeType: 'PERCENTAGE',
          hishRiskHikeType: 'PERCENTAGE',
          ...paramedicReferralChargeEntity,
          doctor: paramedicReferralChargeEntity?.doctor?.id,
          hospital: paramedicReferralChargeEntity?.hospital?.id,
          scheme: paramedicReferralChargeEntity?.scheme?.id,
          procedure: paramedicReferralChargeEntity?.procedure?.id,
          paramedic: paramedicReferralChargeEntity?.paramedic?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.paramedicReferralCharge.home.createOrEditLabel" data-cy="ParamedicReferralChargeCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.home.createOrEditLabel">
              Create or edit a ParamedicReferralCharge
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="paramedic-referral-charge-id"
                  label={translate('tinyMedicRestApp.paramedicReferralCharge.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralCharge.charge')}
                id="paramedic-referral-charge-charge"
                name="charge"
                data-cy="charge"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralCharge.active')}
                id="paramedic-referral-charge-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralCharge.cursor')}
                id="paramedic-referral-charge-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralCharge.microSec')}
                id="paramedic-referral-charge-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralCharge.lastUpdated')}
                id="paramedic-referral-charge-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralCharge.timestampEntry')}
                id="paramedic-referral-charge-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralCharge.referralChargeType')}
                id="paramedic-referral-charge-referralChargeType"
                name="referralChargeType"
                data-cy="referralChargeType"
                type="select"
              >
                {referralChargeTypeValues.map(referralChargeType => (
                  <option value={referralChargeType} key={referralChargeType}>
                    {translate(`tinyMedicRestApp.ReferralChargeType.${referralChargeType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralCharge.addedByType')}
                id="paramedic-referral-charge-addedByType"
                name="addedByType"
                data-cy="addedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralCharge.addedByID')}
                id="paramedic-referral-charge-addedByID"
                name="addedByID"
                data-cy="addedByID"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralCharge.modifiedByType')}
                id="paramedic-referral-charge-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralCharge.modifiedByID')}
                id="paramedic-referral-charge-modifiedByID"
                name="modifiedByID"
                data-cy="modifiedByID"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralCharge.emergencyHike')}
                id="paramedic-referral-charge-emergencyHike"
                name="emergencyHike"
                data-cy="emergencyHike"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralCharge.hishRiskHike')}
                id="paramedic-referral-charge-hishRiskHike"
                name="hishRiskHike"
                data-cy="hishRiskHike"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralCharge.emergencyHikeType')}
                id="paramedic-referral-charge-emergencyHikeType"
                name="emergencyHikeType"
                data-cy="emergencyHikeType"
                type="select"
              >
                {hikeTypeValues.map(hikeType => (
                  <option value={hikeType} key={hikeType}>
                    {translate(`tinyMedicRestApp.HikeType.${hikeType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralCharge.hishRiskHikeType')}
                id="paramedic-referral-charge-hishRiskHikeType"
                name="hishRiskHikeType"
                data-cy="hishRiskHikeType"
                type="select"
              >
                {hikeTypeValues.map(hikeType => (
                  <option value={hikeType} key={hikeType}>
                    {translate(`tinyMedicRestApp.HikeType.${hikeType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralCharge.startDate')}
                id="paramedic-referral-charge-startDate"
                name="startDate"
                data-cy="startDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralCharge.endDate')}
                id="paramedic-referral-charge-endDate"
                name="endDate"
                data-cy="endDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralCharge.suspended')}
                id="paramedic-referral-charge-suspended"
                name="suspended"
                data-cy="suspended"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedicReferralCharge.draft')}
                id="paramedic-referral-charge-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                id="paramedic-referral-charge-doctor"
                name="doctor"
                data-cy="doctor"
                label={translate('tinyMedicRestApp.paramedicReferralCharge.doctor')}
                type="select"
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="paramedic-referral-charge-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.paramedicReferralCharge.hospital')}
                type="select"
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="paramedic-referral-charge-scheme"
                name="scheme"
                data-cy="scheme"
                label={translate('tinyMedicRestApp.paramedicReferralCharge.scheme')}
                type="select"
              >
                <option value="" key="0" />
                {paymentSchemes
                  ? paymentSchemes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="paramedic-referral-charge-procedure"
                name="procedure"
                data-cy="procedure"
                label={translate('tinyMedicRestApp.paramedicReferralCharge.procedure')}
                type="select"
              >
                <option value="" key="0" />
                {hospitalProcedures
                  ? hospitalProcedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="paramedic-referral-charge-paramedic"
                name="paramedic"
                data-cy="paramedic"
                label={translate('tinyMedicRestApp.paramedicReferralCharge.paramedic')}
                type="select"
              >
                <option value="" key="0" />
                {paramedics
                  ? paramedics.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/paramedic-referral-charge" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ParamedicReferralChargeUpdate;
